export default __webpack_public_path__ + "static/media/Mushroom.256.1d4a4e05.png";